import { Outlet } from "react-router-dom";

const RoutsPages = () => {
  return <Outlet />;
};

export default RoutsPages;
